export const PHONE_CODES = [45, 50, 51, 53, 57, 60, 66, 69, 72, 73, 78, 79, 88];
export default function mobilePhone() {
  return `${faker.random.arrayElement(PHONE_CODES)}${faker.helpers.replaceSymbolWithNumber('#######')}`;
}
